/**
 * SkipLinks - Erişilebilirlik için Atlama Bağlantıları
 * Ekran okuyucu ve klavye kullanıcıları için ana içeriğe hızlı erişim
 */
import React from 'react';
import './SkipLinks.css';

/**
 * Skip links komponenti
 * @param {Object[]} links - [{ id: 'main-content', label: 'Ana içeriğe geç' }]
 */
function SkipLinks({ links = [] }) {
    const defaultLinks = [
        { id: 'main-content', label: 'Ana içeriğe geç' },
        { id: 'main-navigation', label: 'Navigasyona geç' }
    ];

    const allLinks = links.length > 0 ? links : defaultLinks;

    const handleClick = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            element.focus();
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <nav className="skip-links" aria-label="Hızlı erişim bağlantıları">
            {allLinks.map((link, index) => (
                <a
                    key={link.id}
                    href={`#${link.id}`}
                    className="skip-link"
                    onClick={(e) => handleClick(e, link.id)}
                    tabIndex={index + 1}
                >
                    {link.label}
                </a>
            ))}
        </nav>
    );
}

export default SkipLinks;
